import {
  MdDashboard,
  MdViewSidebar,
  MdEventNote,
  MdClass,
  MdSupervisorAccount,
  MdSchool,
  MdInventory,
  MdPersonAdd,
  MdPerson,
  MdTextSnippet,
  MdDoorFront,
  MdLibraryBooks,
  MdArticle,
  MdAssignmentInd,
  MdHistory,
  MdPeople,
  MdDomain,
  MdOutlinePerson,
  MdReport,
  MdHome,
  MdContentPaste,
  MdCreditCard,
  MdAirplaneTicket,
  MdPayment, // Import icon baru untuk Manajemen Iuran
  MdReceipt,
  MdAccountBalance,
  MdMonetizationOn, // Import icon untuk FinPay Transactions
} from 'react-icons/md';
import {
  FaBell,
  FaBook,
  FaChalkboard,
  FaLayerGroup,
  FaRegClock,
} from 'react-icons/fa';
import { BsCashCoin } from 'react-icons/bs';
import { FiHome, FiUsers } from 'react-icons/fi';
import { useAuth } from '../../lib/auth-provider/context';
import { useStudentLeavePendingCount } from '../../modules/school/student-leave/contexts/hooks';

export const useMenuItems = () => {
  const { user } = useAuth();
  const isSchoolOperator =
    user.role === 'superoperator' || user.role === 'operator';
  // Dipanggil sebelum cabang role (Rules of Hooks); finance mendapat 403 dari
  // rute pending-count, jadi query hanya aktif untuk operator.
  const { data: pendingLeaveBody } = useStudentLeavePendingCount({
    enabled: isSchoolOperator,
  });
  const pendingLeaveCount = pendingLeaveBody?.data?.pending;

  const MENU_ITEMS = [];

  if (isSchoolOperator) {
    MENU_ITEMS.push(
      {
        groupTitle: 'Home',
        icon: MdHome,
        children: [
          {
            title: 'Dashboard',
            icon: MdDashboard,
            to: '/dashboard',
          },
          {
            title: 'Dashboard Guru',
            icon: MdDashboard,
            to: '/dashboard-hr',
          },
          {
            title: 'Dashboard Absensi Guru',
            icon: MdDashboard,
            to: '/dashboard-teacher-attendance',
          },
          {
            title: 'Kalender Akademik',
            icon: MdViewSidebar,
            to: '/home',
          },
        ],
      },
      {
        groupTitle: 'Data Diri',
        icon: MdOutlinePerson,
        children: [
          {
            title: 'PPDB',
            icon: MdPersonAdd,
            to: '/school/ppdb',
          },
          {
            title: 'Siswa',
            icon: MdPersonAdd,
            to: '/school/student',
          },
          {
            title: 'Guru',
            icon: MdPerson,
            to: '/school/teacher',
          },
          user?.role === 'superoperator' && {
            title: 'Operator',
            icon: MdAssignmentInd,
            to: '/school/operator',
          },
        ].filter(Boolean),
      },
      {
        groupTitle: 'Manajemen Sekolah',
        icon: MdSchool,
        children: [
          {
            title: 'Pengumuman',
            icon: FaBell,
            to: '/school/announcement',
          },
          {
            title: 'Mading',
            icon: FaChalkboard,
            to: '/school/bulletin-board',
          },
          {
            title: 'Artikel',
            icon: MdArticle,
            to: '/school/article',
          },
          {
            title: 'Eskul',
            icon: FaChalkboard,
            to: '/school/extracullicular',
          },

          {
            title: 'Jadwal',
            icon: MdEventNote,
            to: '/school/schedule',
          },
          {
            title: 'Mata Pelajaran',
            icon: MdArticle,
            to: '/school/subject',
          },
          {
            title: 'Kelas',
            icon: MdSupervisorAccount,
            to: '/school/rombel',
          },
          {
            title: 'Ruangan',
            icon: MdDoorFront,
            to: '/school/room',
          },

          {
            title: 'Tahun Ajaran',
            icon: MdClass,
            to: '/school/academic-year',
          },
          {
            title: 'Jurusan',
            icon: MdSchool,
            to: '/school/major',
          },

          {
            title: 'Tingkat',
            icon: MdInventory,
            to: '/school/class',
          },
        ],
      },
      {
        groupTitle: 'Kehadiran',
        icon: MdContentPaste,
        children: [
          {
            title: 'Absen Siswa',
            icon: MdPeople,
            to: '/school/absen-siswa',
          },
          {
            title: 'Absen Guru',
            icon: MdDomain,
            to: '/school/absen-guru',
          },
          {
            title: 'Riwayat Absen Siswa',
            icon: MdPeople,
            to: '/school/riwayat-absen',
          },
          {
            title: 'Riwayat Absen Guru',
            icon: MdDomain,
            to: '/school/riwayat-absen-guru',
          },
          {
            title: 'Riwayat Absen MAPEL',
            icon: MdLibraryBooks,
            to: '/school/riwayat-absen-matpel',
          },
          {
            title: 'Riwayar Absen Eskul',
            icon: MdReport,
            to: '/school/riwayat-absen-eskul',
          },
          {
            title: 'Report Absen',
            icon: MdReport,
            to: '/school/report-attendance',
          },
          {
            title: 'Izin Cuti',
            icon: MdAirplaneTicket,
            to: '/school/vacation',
          },
          {
            title: 'Izin Siswa',
            icon: MdAssignmentInd,
            to: '/school/izin-siswa',
            badge: pendingLeaveCount,
          },
        ],
      },
      {
        groupTitle: 'Keuangan',
        icon: MdCreditCard,

        children: [
          // {
          //   title: 'Riwayat',
          //   icon: MdAccountBalanceWallet,
          //   to: '/payment/history',
          // },
          {
            title: 'Dashboard Keuangan',
            icon: MdDashboard,
            to: '/payment/dashboard',
          },
          // {
          //   title: 'Tagihan',
          //   icon: MdTextSnippet,
          //   to: '/payment/bill',
          // },
          // {
          //   title: 'Slip Gaji',
          //   icon: MdAccountBalanceWallet,
          //   to: '/payment/payroll',
          // },
          // {
          //   title: 'Reimbursement',
          //   icon: MdAssignmentInd,
          //   to: '/payment/reimbursement',
          // },
          {
            title: 'Manajemen Tagihan',
            icon: MdPayment,
            to: '/payment/school-fee',
          },
          {
            title: 'Pembayaran Tunai',
            icon: BsCashCoin,
            to: '/payment/cash',
          },
          {
            title: 'Transaksi Online',
            icon: MdAccountBalance,
            to: '/school/finance/online-transactions',
          },
          {
            title: 'Status Pembayaran',
            icon: MdCreditCard,
            to: '/payment/status-pembayaran',
          },
          {
            title: 'Penarikan Dana',
            icon: MdMonetizationOn,
            to: '/payment/withdraw',
          },
          {
            title: 'Pencatatan Keuangan',
            icon: MdReceipt,
            to: '/payment/pencatatan',
          },
          {
            title: 'Laporan Keuangan',
            icon: MdReport,
            to: '/payment/laporan',
          },
        ],
      },
    );
  } else if (user.role === 'finance') {
    MENU_ITEMS.push({
      groupTitle: 'Keuangan',
      icon: MdCreditCard,
      children: [
        // {
        //   title: 'Riwayat',
        //   icon: MdAccountBalanceWallet,
        //   to: '/payment/history',
        // },
        {
          title: 'Dashboard Keuangan',
          icon: MdDashboard,
          to: '/payment/dashboard',
        },
        // {
        //   title: 'Tagihan',
        //   icon: MdTextSnippet,
        //   to: '/payment/bill',
        // },
        // {
        //   title: 'Slip Gaji',
        //   icon: MdAccountBalanceWallet,
        //   to: '/payment/payroll',
        // },
        // {
        //   title: 'Reimbursement',
        //   icon: MdAssignmentInd,
        //   to: '/payment/reimbursement',
        // },
        {
          title: 'Manajemen Tagihan',
          icon: MdPayment,
          to: '/payment/school-fee',
        },
        {
          title: 'Pembayaran Tunai',
          icon: BsCashCoin,
          to: '/payment/cash',
        },
        {
          title: 'Transaksi Online',
          icon: MdAccountBalance,
          to: '/school/finance/online-transactions',
        },
        {
          title: 'Status Pembayaran',
          icon: MdCreditCard,
          to: '/payment/status-pembayaran',
        },
        {
          title: 'Penarikan Dana',
          icon: MdMonetizationOn,
          to: '/payment/withdraw',
        },
        {
          title: 'Pencatatan Keuangan',
          icon: MdReceipt,
          to: '/payment/pencatatan',
        },
        {
          title: 'Laporan Keuangan',
          icon: MdReport,
          to: '/payment/laporan',
        },
      ],
    });
  }

  return MENU_ITEMS;
};
